var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('v-icon',{attrs:{"size":"1.5rem"}},[_vm._v(" mdi-history ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }